export class PluginRegistry {
    static instance_ = new PluginRegistry();
    loadedPlugins = [];
    /** Method for unregistering all plugins during testing */
    static unregisterAllPlugins() {
        this.instance_.loadedPlugins = [];
    }
    static getPlugin(pluginClass) {
        if (this.instance_.loadedPlugins.some((plugin) => plugin instanceof pluginClass)) {
            return this.instance_.loadedPlugins.find((plugin) => plugin instanceof pluginClass);
        }
        return null;
    }
    static addPlugin(plugin) {
        if (this.instance_.loadedPlugins.some((p) => p.id === plugin.id)) {
            throw new Error(`Plugin with id ${plugin.id} is already registered.`);
        }
        this.instance_.loadedPlugins.push(plugin);
    }
    /**
     * Checks if a plugin with the given name is loaded
     * We use the id instead of the class name to avoid issues with minification
     */
    static checkIfLoaded(pluginName) {
        return !!this.instance_.loadedPlugins.find((plugin) => plugin.id === pluginName);
    }
    /**
     * Retrieves a plugin by its name.
     *
     * This is for debugging from the console and should not be used in production.
     * @deprecated
     *
     * @param pluginName - The name of the plugin to retrieve.
     * @returns The plugin with the specified name, or null if not found.
     */
    static getPluginByName(pluginName) {
        if (this.instance_.loadedPlugins.some((plugin) => plugin.id === pluginName)) {
            return this.instance_.loadedPlugins.find((plugin) => plugin.id === pluginName);
        }
        return null;
    }
}
